module.exports = __webpack_public_path__ + "./docs/img/icon-constants.50a15de0977dda242788327652f65217.svg";